import { render, staticRenderFns } from "./PersonalisationToolbar.vue?vue&type=template&id=11dfe10c"
import script from "./PersonalisationToolbar.vue?vue&type=script&lang=ts"
export * from "./PersonalisationToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports